/**
 * OVERRIDE CookieBanner.jsx
 */

import CookieBanner from '../../../../components/Cookies/CookieBanner';

export default CookieBanner;